import React from 'react';
import { string } from 'prop-types';

import styles from './Reminder.scss';
import notificationIcon from '@dragonfruit/images/icons/ic_notification.svg';

export default function Reminder({ title, description }) {
  return (
    <div className={styles.root}>
      <img
        className={styles.icon}
        src={notificationIcon}
        alt="notification icon"
      />
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
}

Reminder.propTypes = {
  description: string.isRequired,
  title: string.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/Reminder/Reminder.jsx